<template>
  <div>
    <div v-click-outside="closeSidebar" class="sidebar bg-bar-color" :data="backgroundColor" :style="{background:this.$global.globalSidebarBgColor}" style="z-index: 99;">
      <div class="sidebar-wrapper" ref="sidebarScrollArea">
        <div class="logo">
          <div style="width:100%">
            <a href="#" class="simple-text logo-normal text-center">
          
              <img id="companylogosidebar" style="max-width:125px" :src="this.$global.globalCompanyPhoto" alt="app-logo" />
            </a>
            <div id="sidebarCompanyName" class="simple-text logo-normal text-center text-bar-color" :style="{color:this.$global.globalTextColor}" style="word-wrap: break-word;white-space: break-spaces;">
             {{ this.$global.globalCompanyName }}
            </div>
            <!-- <small class="company-select-tag text-bar-color" v-if="this.$global.settingMenuShow && !this.$global.systemUser && this.$global.creditcardsetup && this.$global.stripeaccountconnected" :style="{color:this.$global.globalTextColor}" style="display:inline-block;width:100%;text-align:center;font-size:100%;padding-top:5px;font-size:12px">View By Client Name :</small> -->
            <!-- <div v-if="this.$global.settingMenuShow && !this.$global.systemUser && this.$global.creditcardsetup && this.$global.stripeaccountconnected" style="text-align:center" class="pt-2">
              <select style="font-size:12px;width:80%" v-model="selectedGroupCompany" v-on:change="onGroupChange($event)">
                <option  v-for="(item, index) in this.$global.selectsGroupCompany.companyGroupList" :key="index" :value="item.id">{{ item.group_name }}</option>
              </select>
            
            </div> -->
          </div>
        </div>
        <slot></slot>
        <ul class="nav sidebar-item-wrapper text-bar-color" :style="{color:this.$global.globalTextColor}">
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink"
              >
              </sidebar-item>
            </sidebar-item>
          </slot>
        </ul>
        <!-- <div style="margin-inline: 30px; display: flex; align-items: center;" class="sidebar__logout__button" @click="logout">
          <i class="fa-solid fa-arrow-right-from-bracket" style="font-size: 20px; width: 34px; color: rgba(255, 255, 255, 0.8);"></i>
          <p class="text-bar-color" style="margin: 0; line-height: 30px; text-transform: uppercase; font-size: 12px;">Log out</p>
        </div> -->
        <div :class="this.$sidebar.isMinimized ? 'sidebar-profile-section-setup' : ''"><el-dropdown>
              <span class="el-dropdown-link">
                <div class="user-image"><img id="topnavphoto" :src="this.$global.globalProfilePhoto" /></div><i class="el-icon-caret-bottom el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="width: 250px;">
                <router-link :to="profileSetupLink" v-if="this.$global.menuUserType != 'sales'">
                  <el-dropdown-item :class="{'dropdown-active': $route.path === profileSetupLink}">
                    Profile
                  </el-dropdown-item>
                </router-link>
                <router-link to="/user/card-setting" v-if="(this.$global.creditcardsetup && this.$store.getters.userData.manual_bill == 'F') || (this.$global.creditcardsetup && this.$store.getters.userData.manual_bill == 'T' && this.$store.getters.userData.user_type == 'userdownline')">
                  <el-dropdown-item :class="this.$route.path == '/user/card-setting' && 'dropdown-active'">
                    Card Setting
                  </el-dropdown-item>
                </router-link>
                <a 
                  href="#" 
                  @click="showModalPrepaidDirectPayment" 
                  v-if="(userData.user_type == 'userdownline' || userData.user_type == 'user') && this.$global.masteridsys == this.$global.idsys && !this.$global.systemUser && this.validateBetaFeature('data_wallet')">
                  <el-dropdown-item>
                    <BetaBadge position="center" :isShow="this.$global.betaFeature.data_wallet.is_beta && (this.$global.betaFeature.data_wallet.apply_to_all_agency || this.$global.isBeta)">
                      Data Wallet
                    </BetaBadge>
                  </el-dropdown-item>
                </a>
                
                <router-link 
                  to="/integrations" 
                  v-if="this.$store.getters.userData.user_type === 'client' && this.$global.hasVisibleIntegrations">
                  <el-dropdown-item :class="this.$route.path == '/integrations' && 'dropdown-active'">
                    Integrations
                  </el-dropdown-item>
                </router-link>
                <!-- <a href="#" @click="popOpenApi" v-if="this.$store.getters.userData.user_type == 'user' || this.$store.getters.userData.user_type == 'userdownline'"> -->
                <a href="#" @click="showModalDeveloper" v-if="this.$global.apiMode && this.$global.rootcomp && ((this.$global.systemUser && (this.$store.getters.userData.user_type == 'user' || this.$store.getters.userData.user_type == 'userdownline')) || (!this.$global.systemUser && (this.$store.getters.userData.user_type == 'user' || this.$store.getters.userData.user_type == 'userdownline') && this.$global.creditcardsetup && this.$global.stripeaccountconnected))">
                  <el-dropdown-item>
                    Developer
                  </el-dropdown-item>
                </a>
                <a href="#" @click="popWhiteList" v-if="(this.$store.getters.userData.user_type == 'client' || ((this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') && !this.$global.systemUser))">
                  <el-dropdown-item>
                    Exclusion List
                  </el-dropdown-item>
                </a>
                <a href="#" @click="popResetPassword">
                  <el-dropdown-item>
                    Change Password
                  </el-dropdown-item>
                </a>
                <a href="#" @click="onOpenModalTwoFactorAuth">
                  <el-dropdown-item>
                    {{ isLoadingGetTwoFactorAuth ? 'Loading...' : 'Two Factor Authentication' }}
                  </el-dropdown-item>
                </a>
                <a href="#" v-on:click.stop.prevent="logout">
                <el-dropdown-item divided>
                  Log out
                </el-dropdown-item>
              </a>
              </el-dropdown-menu>
            </el-dropdown>
    
            <a v-if="!this.$global.systemUser && this.$global.agencyplatformroot && (this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user')" target="_blank" href="https://connect.exactmatchmarketing.com/support-tickets" class="logout-btn" :style="{color:this.$global.globalTextColor,fontSize: '22px'}" ><span class="d-flex align-items-center" style="gap: 8px;">  
              <!-- <i class="fa-light fa-user-headset"></i>   -->
              <!-- <i class="fa-regular fa-message-question"></i> -->
              <i class="fa-solid fa-headset text-bar-color"></i> 
              <span style="font-size: 12px; font-weight: 600;" class="text-bar-color">Support</span></span> </a>
          </div>
      </div>
  
    </div>
         <!-- Modal Update Password -->
        <modal id="modalUpdatePassword" :show.sync="modals.updatepassword" headerClasses="justify-content-center"
        modalContentClasses="modal-updatepassword">
        <h4 slot="header" class="title title-up">Change Password</h4>
        <div class="text-center">
          <img src="/img/reset-password.png" />
        </div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form ref="frmresetlogin" @submit.prevent="handleSubmit(ProcessResetPassword)">
            <ValidationProvider name="current password" rules="required" v-slot="{ passed, failed, errors }">
              <div class="password-icon">
              <base-input :disableAutoPasswordValidation="true" id="currpassword-sidebar" v-model="currpassword" :type="showPassword ? 'text' : 'password'" label="Your current password"
                autocomplete="chrome-off" :error="errors[0]" :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
              </base-input>
             <button
                type="button"
                class="icon-password"
                @click="togglePassword"
                >
               <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>  
        </ValidationProvider>

            <ValidationProvider name="new password" rules="required|confirmed:confirmation"
              v-slot="{ passed, failed, errors }">
              <div class="password-icon">
                <base-input :is-password-field="true" id="newpwd-sidebar" v-model="password" :type="showCurentPassword ? 'text' : 'password'" label="New Password" autocomplete="chrome-off"
                :error="errors[0]" :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
              </base-input>
                <button
                  type="button"
                  class="icon-password"
                  @click="toggleCurrentPassword"
                  >
                  <i :class="showCurentPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </ValidationProvider>
  
            <ValidationProvider name="Confirm New Password" vid="confirmation" rules="required"
              v-slot="{ passed, failed, errors }"
             >
             <div class="password-icon">
              <base-input :is-password-field="true" id="confpassword-sidebar" v-model="confirmation" :type="showConfirmPassword ? 'text' : 'password'" label="Confirm New Password"
                autocomplete="chrome-off" :error="errors[0]" :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
              </base-input>
               <button
                  type="button"
                  class="icon-password"
                  @click="toggleConfirmPassword"
                  >
                  <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
             </div>
            </ValidationProvider>
      
         
  
            <div class="container text-center pt-4">
              <button :disabled="isSubmittingResetPassword" type="submit" class="btn">{{ btnResetPasswordText }}</button>
            </div>
            <small v-if="errorupdatepassword"><span style="color:#ec250d">* Sorry, your current password
                invalid</span></small>
          </form>
        </ValidationObserver>
        <template slot="footer">
  
        </template>
      </modal>
      <!-- Modal Update Password -->
  
      <!-- Modal Two Factor Auth -->
      <modal headerClasses="justify-content-center" :show.sync="modals.twofactorauth" class="modal__2fa">
        <h4 slot="header" class="title title-up">Two Factor Authentication</h4>
        <div class="text-center" style="padding-bottom: 16px;">
          <img src="/img/2fa.jpg" alt="auth" style="max-width: 250px;" />
        </div>
        <div style="display: flex; justify-content: center; padding-bottom: 16px;">
          <p class="text-center" style="font-weight: bold;">We'll now ask for a login code anytime you log in on a device we don't recognize</p>
        </div>
        <div style="display: flex; flex-direction: column; gap: 16px; align-items: center;">
          <el-card style="width: 80%; cursor: pointer; position: relative;" :class="two_factor_auth_type == 'email' ? 'two__fa__active' : ''" @click.native="onHandleSelectTwoFactorAuth('email')" :shadow="two_factor_auth_type == 'email' ? 'always' : 'hover'">
              <div class="row" style="align-items: center;">
                <div style="padding-inline: 16px;">
                  <i class="fa-solid fa-at" style="font-size: xx-large;" :class="two_factor_auth_type == 'email' ? 'two__fa__icon__active' : 'text-gray'"></i>
                </div>
                <div>
                  <p :style="{color: two_factor_auth_type== 'email' ? '#409eff !important' : 'gray !important'}">Email Verification</p>
                </div>
                <span v-if="two_factor_auth_type == 'email'" style="top: 0; right: 0; position: absolute; background-color: green; color: white; padding: 0px 8px; font-size: 12px;">
                  Enabled
                </span>
                <span v-else style="top: 0; right: 0; position: absolute; background-color: gray; color: white; padding: 0px 8px; font-size: 12px;">
                  Disabled
                </span>
            </div>
          </el-card>
          <el-card style="width: 80%; cursor: pointer; position: relative;" :class="two_factor_auth_type == 'google' ? 'two__fa__active' : ''" @click.native="onHandleSelectTwoFactorAuth('google')" :shadow="two_factor_auth_type == 'google' ? 'always' : 'hover'">
              <div class="row" style="align-items: center;">
                <div style="padding-inline: 16px;">
                  <i class="fas fa-mobile-alt" style="font-size: xx-large;" :class="two_factor_auth_type == 'google' ? 'two__fa__icon__active' : 'text-gray'"></i>
                </div>
                <div>
                  <p :style="{color: two_factor_auth_type== 'google' ? '#409eff !important' : 'gray !important'}">Authenticator App</p>
                </div>
                <span v-if="two_factor_auth_type == 'google'" style="top: 0; right: 0; position: absolute; background-color: green; color: white; padding: 0px 8px; font-size: 12px;">
                  Enabled
                </span>
                <span v-else style="top: 0; right: 0; position: absolute; background-color: gray; color: white; padding: 0px 8px; font-size: 12px;">
                  Disabled
                </span>
            </div>
          </el-card>
          <!-- <el-card style="width: 80%; cursor: pointer;" :class="two_factor_auth_type == 'text_messaging' ? 'two__fa__active' : ''" @click.native="onHandleSelectTwoFactorAuth('text_messaging')" :shadow="two_factor_auth_type == 'text_messaging' ? 'always' : 'hover'">
              <div class="row" style="align-items: center;">
                <div style="padding-inline: 16px;">
                  <i class="el-icon-message" style="font-size: xx-large;" :class="two_factor_auth_type == 'text_messaging' ? 'two__fa__icon__active' : 'text-gray'"></i>
                </div>
                <div>
                  <p :style="{color: two_factor_auth_type== 'text_messaging' ? '#409eff !important' : 'gray !important'}">Text Messaging</p>
                </div>
            </div>
          </el-card> -->
          </div>
          <div style="display:  flex; justify-content: center; margin-top: 31px; margin-bottom: 16px;">
            <button :disabled="isLoadingSaveTwoFactorAuth" type="submit" class="btn" @click="onClickTwoFactorAuth">{{ isLoadingSaveTwoFactorAuth ? 'Loading....' : 'Save' }}</button>
          </div>
        </modal>
        <!-- Modal Two Factor Auth -->
        
        <!-- Modal Children Google Auth -->
        <modal headerClasses="justify-content-center" :show.sync="modals.googleAuth" class="modal__2fa">
          <h4 slot="header" class="title title-up">Authenticator App</h4>
          <div class="row" v-if="isLoadingGetGoogleTwoFactorAuth">
            <div class="col-12" style="display: flex; justify-content: center;">
              <i class="fas fa-spinner fa-spin" style="font-size: 24px; padding-block: 100px;"></i>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-12" style="margin-bottom: 24px;">
              <div>
                <p class="text-center" style="font-weight: 600;">Download the app.</p>
                 <div class="container d-flex text-nowrap ml-3 mb-3">
                   <p class="fw-bold mb-2 mr-1">For Android : </p>
                     <div class="row justify-content-center g-3">
                     <div class="col-6 col-sm-6 col-md-6" v-for="item in googleAuthApps":key="item.id"><a target="_blank":href="item.linkAndroid"class="fs-6 d-block  text-decoration-none">{{ item.name }}</a></div>
                  </div>
                </div>

               <div class="container d-flex text-nowrap ml-3 mb-3">
                  <p class="fw-bold mb-2 mr-1">For Iphone : </p>
                      <div class="row justify-content-center g-3">
                      <div class="col-6 col-sm-6 col-md-6" v-for="item in googleAuthApps":key="item.id"><a target="_blank":href="item.linkIphone"class="fs-6 d-block  text-decoration-none">{{ item.name }}</a></div>
                  </div>
                </div>
              </div>

              <div style="margin-top: 16px; margin-bottom: 16px;">
                <p class="text-center" style="font-weight: 600;">Scan this code with the app</p>
              </div>
              <div style="display: flex; justify-content: center;">
                <img :src="qrCodeUrl" alt="two factor google" v-if="qrCodeUrl" />
              </div>
              <div style="margin-top: 16px;">
                <p class="text-center">Or enter the following code manually:</p>
                <p class="text-center" style="font-weight: 600;">{{ secretKey }}</p>
              </div>
            </div>
            <div class="col-6">
              <base-button class="btn-danger" :disabled="isLoadingGetTwoFactorAuth" @click="onHandleCancelGoogleTwoFactorAuth" style="width: 100%;">{{ isLoadingGetTwoFactorAuth ? 'Loading...' : 'Cancel' }}</base-button>
            </div>
            <div class="col-6">
              <base-button :disabled="isLoadingSaveGoogleTwoFactorAuth" style="width: 100%;" @click="onClickSaveGoogle">{{ isLoadingSaveGoogleTwoFactorAuth ? 'Loading...' : 'Save' }}</base-button>
            </div>
          </div>
      </modal>
      <!-- Modal Children Google Auth -->

      <!-- WhiteList DB upload -->
      <modal v-if="(this.$store.getters.userData.user_type == 'client' || ((this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') && !this.$global.systemUser))" :show.sync="modals.whitelist" id="clientWhitelist" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">{{ this.$store.getters.userData.user_type == 'client' ? 'Client' : 'Agency' }} Wide Exclusion List</h4>
        <div>
          <!--UPLOAD-->
          <form enctype="multipart/form-data">
            <!--<h5>Drag & Drop your suppression List (file type should be .csv). Download <a href="#">example file</a></h5>-->
            <div class="dropbox">
              <input type="file" :name="uploadFieldName" :disabled="isSaving"
                @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                accept=".csv" class="input-file">
              <p v-if="isInitial">
                Drag your file here to upload<br />or click to browse<br />
                <!--<base-button type="info" round icon  @click="show_helpguide('suppression')">
                    <i class="fas fa-question"></i>
                </base-button>-->
              </p>
              <p v-if="isSaving">
                Please Wait, your file being upload ...
              </p>
              <p v-if="isSuccess">
                Your Suppression file has been Submitted, Thank you!
              </p>
              <p v-if="isFailed">
                Whoops that did not work, please check your file for errors and try again
              </p>
            </div>
          </form>
        </div>
        <div v-if="supressionProgress.length > 0">
            <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
            <div v-for="(value) in supressionProgress" :key="value.id">
                <div style="display: flex; width: 100%; gap: 8px;">
                    <img src="/img/csv-logo.png" alt="csv-logo" style="height: 60px;" />
                    <div style="width: 100%;">
                        <p style="color: #000000; font-weight: 600; margin-bottom: 0px; word-break: break-all;">{{ value.filename }}</p>
                        <el-progress :percentage="value.percentage == null ? 0 : value.percentage"></el-progress>
                        <p style="margin-bottom: 0px; opacity: 0.8;">{{ value.current_row }} of {{ value.total_row }} rows</p>
                    </div>
                </div>
                <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
            </div>
        </div>
        <div class="pt-2 mt-3">
          You have the ability to restrict your current database from being identified as a new contact. 
                          You can Exclude them by uploading a list of MD5 encrypted email addresses, 
                          or by uploading a list of email addresses and we will encrypt them for you. 
                          Do not include any other information in the file aside from the email address. 
                          You may upload lists of up to 10,000 records at a time. <a
                            href='https://app.exactmatchmarketing.com/samplefile/suppressionlist.csv' target='_blank'>Click here</a> to download a Sample File
          <div class="text-center" v-if="optoutfileexist">
            Your current exclusion list: 
            <a :href="optoutpath + '/tools%2Foptout%2Fclientoptoutlist_' + whiteListClientID + '.csv'"
              target="_blank">
              download here
            </a>
          </div>
        </div>
        <div v-if="supressionDone.length > 0">
            <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
            <div v-for="(value) in supressionDone" :key="value.id">
                <div style="display: flex; width: 100%; gap: 8px;">
                    <img src="/img/csv-logo.png" alt="csv-logo" style="height: 60px;" />
                    <div style="width: 100%;">
                        <p style="color: #000000; font-weight: 600; margin-bottom: 0px; word-break: break-all;">{{ value.filename }}</p>
                        <el-progress :percentage="value.percentage" status="success"></el-progress>
                        <p style="margin-bottom: 0px; opacity: 0.8;">{{ value.current_row }} of {{ value.total_row }} rows</p>
                    </div>
                </div>
                <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
            </div>
        </div>
        <a class="mt-2 d-inline-block" @click="purgeSuppressionList('client')" style="cursor: pointer;">
          <i class="fas fa-trash"></i> Purge Existing Records
        </a>
        <template slot="footer">
          <div class="pb-4 d-flex justify-content-center w-100">
            <base-button @click.native="modals.whitelist = false">Cancel</base-button>
          </div>
        </template>
      </modal>
      <!-- WhiteList DB upload -->

      <!-- Open Api -->
      <modal v-if="this.$store.getters.userData.user_type !== 'client' && (this.$global.idsys == this.$global.masteridsys && this.$global.apiMode)" id="modalOpenApi" :show.sync="modals.openapi" headerClasses="justify-content-center" modalContentClasses="modal-openapi">                
        <div slot="header" style="position: relative; width: 100%;">
          <h4 class="title title-up" style="text-align: center;">API KEY</h4>
        </div>
        
        <!-- <span style="position: absolute; top: 20px; left: 0;">url : {{ openApiBaseUrl }}</span>
        <h4 slot="header" class="title title-up">API KEY</h4> -->
        <div v-if="(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') && (!this.$global.systemUser)" class="pl-0 col-12"  style="font-weight: 500;"><strong>API endpoint URL :</strong> {{ openApiBaseUrl }}</div>
        <form ref="frmOpenApi">
          <div style="display: flex; align-items: center; gap: 0.5rem;">
            <div style="width: 100%;">
              <span class="demo-input-label">Client ID</span>
              <el-input
                :type="openApiVisibility.clientID ? 'text' : 'password'"
                v-model="openApiClientID"
                :readonly="true">
                <i @click="toggleInputOpenApi('client_id')" slot="suffix" :class="openApiVisibility.clientID ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'" style="margin: 0.8rem 0.15rem; cursor: pointer;"></i>
              </el-input>
            </div>
            <base-button @click="copyInputOpenApi('client_id')" style="margin-top: 2rem;">
              Copy
            </base-button>
          </div>
          
          <div style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem">
            <div style="width: 100%;">
              <span class="demo-input-label">Secret Key</span>
              <el-input
                :type="openApiVisibility.secretKey ? 'text' : 'password'"
                v-model="openApiSecretKey"
                :readonly="true">
                <i @click="toggleInputOpenApi('secret_key')" slot="suffix" :class="openApiVisibility.secretKey ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'" style="margin: 0.8rem 0.15rem; cursor: pointer;"></i>
              </el-input>
            </div>
            <base-button @click="copyInputOpenApi('secret_key')" style="margin-top: 2rem;">
              Copy
            </base-button>
          </div>
          
          <div class="pt-3">
            <div v-if="(this.$store.getters.userData.user_type == 'userdownline' || this.$store.getters.userData.user_type == 'user') && (!this.$global.systemUser)">
              <div class="link-developer" @click="apiDocumentation"><i class="fas fa-external-link-alt"></i> api documentation</div>
              <div class="link-developer" @click="downloadStateCity"><i class="fas fa-download"></i> Download list of states and cities</div>
            </div>
            <div class="text-center w-100 pt-3">
              <base-button :disabled="isLoadingGenerateApiKey" @click="generateAuthenticateOpenApi">
                {{ btnOpenApiText }} <i v-if="isLoadingGenerateApiKey" class="fas fa-spinner fa-spin ml-1" style="font-size: 16px;"></i>
              </base-button>
            </div>
          </div>
        </form>
      </modal>
      <!-- Open Api -->

      <!-- MODAL TERM OF BILLING OPEN API -->
      <modal :show.sync="modals.billingAgreement" headerClasses="justify-content-center" id="modaltermofbilling">
        <h4 slot="header" class="title title-up">Developer Agreement</h4>
        <div>
          <iframe v-if="modals.billingAgreement" :key="'dev-agreement-' + ($store.getters.userData && $store.getters.userData.id)" src="/marketing-services-agreement-developer" width="100%"  height="400vh" />
        </div>
        <div v-if="!this.$global.systemUser" class="pl-5 pr-5 pt-3">
          <base-checkbox v-model="checkbox_developer_api_paid">{{ agree_developer_api_paid }}</base-checkbox>
        </div>
        <div class="footer-section-developer-agreement">
          <div class="link-developer" @click="apiDocumentation"><i class="fas fa-external-link-alt"></i> api documentation</div>
          <div>
            <base-button :disabled="isLoadingMarketingServicesAgree || (!this.$global.systemUser && !checkbox_developer_api_paid)" @click="agreedtermofbilling();"><i v-if="isLoadingMarketingServicesAgree" class="el-icon-loading" style="margin-right: 4px; font-size: 18px;"></i> Yes I Agree</base-button>
          </div>
          <div></div>
        </div>
        <!-- <div class="container text-center" style="padding-bottom: 30px; border: 1px solid black; display: flex; justify-content: center;">
          <div class="link-developer mt-2" @click="apiDocumentation"><i class="fas fa-external-link-alt"></i> api documentation</div>
          <base-button :disabled="isLoadingMarketingServicesAgree" @click="agreedtermofbilling();"><i v-if="isLoadingMarketingServicesAgree" class="el-icon-loading" style="margin-right: 4px; font-size: 18px;"></i> Yes I agree</base-button>
        </div> -->
      </modal>
      <!--MODAL TERM OF BILLING OPEN API -->
      
      <!-- DATA WALLET -->
      <modal :show.sync="modals.directPayment" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">Data Wallet for {{ userData.company_name }}</h4>
        
        <div style="display: flex; flex-direction: column; gap: 16px;">
          <el-card shadow="never" class="info-panel">
            <p>Your current spend as of {{ agencyMinimumSpendStartDate }} is <strong>${{ agencyTotalWholesaleSpend }}</strong>.</p>
            <p>Your minimum spend goal by {{ agencyMinimumSpendEndDate }} is <strong>${{ agencyminimumPlatformSpend }}</strong>.</p>
            <p v-if="Number(agencyminimumSpendBilling) === 0">You've met your minimum spend goal.</p>
            <p v-else>You need an additional <strong :style="{ color: (Number(agencyminimumSpendBilling) > 0 ? '#7a0e16' : '#000000') }">${{ agencyminimumSpendBilling }}</strong> to reach your goal.</p>
            <div class="notes-section">
              <p>Your data wallet balance can be used for transactions related to eligible campaign activities, including payments, refunds, and approved agency expenses. Please note that not all modules support payments through the data wallet.</p>
              <p>If your minimum spend goal is not met by the end of the period, the difference between your <strong>current spend</strong> and the <strong>minimum spend goal</strong> will automatically be added to your data wallet balance.</p>
              <p>Each top-up or credited amount remains valid for <strong>12 months</strong> from the date it's added. After this period, any unused balance from that top-up will expire.</p>
            </div>
          </el-card>
          
          <el-card shadow="never">
            <p style="font-size: 18px; font-weight: 600; margin-bottom: 0px;"><span style="opacity: 0.7;">Your balance : </span> ${{ balanceDirectPayment }} </p>
          </el-card>
          
          <el-card shadow="never" v-if="isEnableTopupPrepaidDirectPayment">
            <p style="margin-bottom: 0px;"><span style="font-weight: 600;">Continual top up</span> will automatically top up your pool of pre-purchased contacts when it gets low. This will keep your campaign running until stopped.</p>
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-6" style="padding-top: 16px;">
                <base-button 
                  v-if="Number(this.amountDirectPayment) > 0"
                  style="max-width: 250px;"
                  class="text-white"
                  @click="stopContinualTopupDirectPayment"
                  :class="{'bg-gray': isStopContinualDirectPayment, 'bg-danger': !isStopContinualDirectPayment}">
                    <span>{{ wordingStopContinualDirectPayment }}</span>
                </base-button>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6" style="padding-block: 16px;">
                <!-- <p style="margin-bottom: 0px; font-weight: 600;">Automatic top up will occur when your pre-purchased amount drops below $1</p> -->
                <p style="margin-bottom: 0px; font-weight: 600;">
                  Automatic top-up will occur when your pre-purchased amount drops below 10% of 
                  <!-- <span v-if="balanceDirectPayment > 0">${{ lastBalanceAmountDirectPayment }}, which is ${{ (10 * lastBalanceAmountDirectPayment / 100).toFixed(2) }}</span> dulu 10% auto topup data wallet itu acuan dari last_balance_amount -->
                  <span>${{ amountDirectPayment }}, which is ${{ (10 * amountDirectPayment / 100).toFixed(2) }}</span> <!-- sekarang 10% auto topup data wallet acuan nya dari amount yang di setup  -->
                  <!-- <span v-else>last setup amount</span> -->
                </p>
              </div>
            </div>
          </el-card>

          <el-card shadow="never" v-if="isEnableTopupPrepaidDirectPayment">
            <label style="font-weight: 600;">Choose an amount :</label>
            <div class="row" style="margin-top: 4px;">
              <div class="col-sm-6 col-md-3 col-lg-3" v-for="(value) in chooseAmount" :key="value.id" style="padding-block: 15px;">
                <el-card :shadow="!customAmountDirectPayment ? (activeIndexAmount === value.id ? 'always' : 'hover') : 'never'" class="cursor-pointer" :class="[activeIndexAmount === value.id ? 'active-amount' : '',  customAmountDirectPayment ? 'disabled-card' : '']" @click.native="onActiveIndexAmount(value)">
                    <div style="display: flex; justify-content: center;">
                      <i class="fas fa-money-check-alt" style="font-size: 24px;"></i>
                    </div>
                    <p style="margin-bottom: 0px; text-align: center; font-size: 16px; font-weight: 600;">${{value.amount}}</p>
                </el-card>
              </div>
            </div>
            <div style="margin-top: 16px;">
              <!-- <el-input placeholder="How much do you want to top up?" v-model="amountDirectPayment" type="number">
                <template slot="prepend">$</template>
              </el-input> -->
              <div>
                <el-checkbox v-model="customAmountDirectPayment">Custom Amount</el-checkbox>
              </div>
              <base-input 
                maxLength="20"
                label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign" class="campaign-cost-input" style="margin-top: 4px;"
                :class="!customAmountDirectPayment && 'disabled'" v-model="amountDirectPayment" @keydown="restrictInput" @blur="blurInputAmountDirectPayment" @keyup="keyupInputAmountDirectPayment" @copy.prevent @cut.prevent @paste.prevent>
              </base-input>
              <div v-if="errMinimumAmountDirectPayment" style="color:#942434; font-size: .75rem;">
                <span>*Minimum amount is ${{ minimumAmountDirectPayment }}</span>
              </div>
            </div>
          </el-card>
          
          <el-card shadow="never">
            <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
              <p style="font-size: 16px; font-weight: 600; margin-bottom: 0px;">History</p>
              <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                <div>
                  <el-date-picker v-model="dateTransactionHistoryDirectPayment" @change="changeDateTransactionHistoryDirectPayment" type="month" placeholder="Pick a month" :editable="false"></el-date-picker>
                </div>
                <base-button size="sm" style="height:40px;" @click="downloadTransactionHistoryDirectPayment">
                  <i class="fas fa-cloud-download-alt pr-2"></i> Download Data
                </base-button>
              </div>
            </div>
            <div v-if="fetchTransactionHistoryDirectPayment">
              <div style="min-height: 6vh; display: flex; justify-content: center; align-items: center;">
                <i class="fas fa-spinner fa-spin" style="font-size: 20px;"></i>
              </div>
            </div>
            <div v-else>
              <div style="margin-top: 16px; overflow-y: auto; max-height: 320px;" v-if="transactionHistoryDirectPayment.length > 0">
                <div v-for="(item) in transactionHistoryDirectPayment" :key="item.id" style="padding-right: 10px;">
                  <div style="display: flex; justify-content: space-between; gap: 16px; align-items: center;">
                    <div style="display: flex;">
                      <div style="display: flex; flex-direction: column;">
                        <p style="margin-bottom: 0px; font-weight: 600;">{{ item.title }}</p>
                        <p v-if="item.transaction_type === 'charge' && item.sub_title" style="margin-bottom: 0px; font-size: 13px; opacity: 0.7; margin-top: 2px;">{{ item.sub_title }}</p>
                        <span style="opacity: 0.8;">{{ item.created_at }}</span>
                      </div>
                      <div v-if="item.expired_at" style="display: flex; flex-direction: column; border-left: 1px solid #888; margin-left: 1rem; padding-left: 1rem;">
                        <p style="margin-bottom: 0px; font-weight: 600;">Expired</p>
                        <span style="opacity: 0.8;">{{ item.expired_at }}</span>
                      </div>
                    </div>
                    <div>
                      <p :style="'font-weight: 600; color: ' + getColorTransaction(item.transaction_type) + ' !important;'">${{ item.amount }}</p>
                    </div>
                  </div>
                  <div style="border-top: 1px solid #ccc; margin: 16px 0;"></div>
                </div>
              </div>
              <div style="margin-top: 16px; display: flex; justify-content: center; align-items: center;" v-else>
                <p>No transaction history available.</p>
              </div>
            </div>
          </el-card>
        </div>

        <template slot="footer" v-if="isEnableTopupPrepaidDirectPayment">
          <div style="width: 100%; padding-top: 16px; padding-bottom: 24px; padding-inline: 18px;">
            <div class="row">
              <div class="col-12 d-flex justify-content-center align-items-center">
                <base-button 
                  class="button-save-or-charge-prepaid-direct-payment"
                  :disabled="popProcessing" 
                  :style="{cursor: popProcessing ? 'not-allowed !important' : ''}" 
                  @click="saveOrChangePrepaidDirectPayment" 
                  v-text="Number(amountDirectPayment) <= 0 ? 'Save' : 'Top Up Balance'">
                </base-button>
              </div>

              <!-- <div class="col-6">
                <base-button style="width: 100%; background: gray;" :disabled="popProcessing" :style="{cursor: popProcessing ? 'not-allowed !important' : ''}" @click="savePrepaidDirectPayment">Save</base-button>
              </div>
              <div class="col-6">
                <base-button style="width: 100%;" :disabled="popProcessing" :style="{cursor: popProcessing ? 'not-allowed !important' : ''}" @click="chargePrepaidDirectPayment">
                  <i v-if="popProcessing" class="el-icon-loading" style="margin-right: 4px; font-size: 18px;"></i>
                  Top Up Balance
                </base-button>
              </div> -->

            </div>
          </div>
        </template>
      </modal>
      <!-- MODAL TERM OF BILLING-->
      <el-dialog 
          :visible.sync="dataWalletAgreementDialog"
          title="Service Agreement"
          width="80%"
          center>
            <div>
              <p v-if="false" style="color: #000000; word-break: break-word; line-height: 1.5rem;">I understand that any features marked as beta in the system are under development and not released for commercial use. Any commercial use of these features are undertaken by the client for their use and are not warranted against errors.</p>
            </div>
            <div style="margin-top: 1rem;">
              <p style="color: #000000; word-break: break-word; line-height: 1.5rem;">I understand that Data Wallet has no monetary value, is not exchangeable for cash or any other form of compensation, is non-refundable under any circumstances, and will automatically expire after 12 months if unused.</p>
            </div>
            <div class="text-center" style="margin-top: 2rem;">
              <base-button :disabled="isLoadingMarketingServicesFeature" @click="agreedTermFeature($global.betaFeature.data_wallet.id, $global.betaFeature.data_wallet.slug, $global.betaFeature.data_wallet.name);"><i v-if="isLoadingMarketingServicesFeature" class="el-icon-loading" style="margin-right: 4px; font-size: 18px; "></i> Yes I agree</base-button>
            </div>
          <!-- <div class="container text-center pb-4">
            <a href="https://docs.google.com/document/d/1s7DWDCcABVL39YcOtor468qQMh3iZH_Te5-tIDgqMew/edit?tab=t.0" target="_blank">Click here for client service agreement</a>  
          </div> -->
      </el-dialog>
      <!--MODAL TERM OF BILLING -->
      <!-- DATA WALLET -->

      <!-- SERVICE AGREEMENT MODAL -->
      <el-dialog 
          :visible.sync="serviceAgreementDialog"
          title="Service and Billing Agreement"
          width="45%"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          center>
          <div>
            <iframe ref="iframeRefAgreement" :src="`/service-billing-agreement${minSpend ? '?version=4' : ''}`" width="100%" height="400vh" style="border-radius: 8px;" @load="onIframeLoadAgreement" />
          </div>
          <div class="pl-3 pr-3 pt-3">
            <base-checkbox :disabled="agreeTermDisableModal" v-model="agreeTermBillingModal" :class="{'has-danger': agreeTermBillingModalError}">I read and Agree with Service and Billing Agreement</base-checkbox>
          </div>
          <div class="pl-3 pr-3 pt-2 agreement-charge-label-wrap" v-if="(minSpend || is_onboard_price_modal > 0) && $store.getters.userData.user_type != 'client'">
            <base-checkbox :disabled="agreeTermDisableModal" v-model="agreementChargeModal" :class="{'has-danger': agreementChargeModalError}">
              <span v-if="!excludeOnBoardingModal && is_onboard_price_modal > 0" class="agreement-charge-label-text">
                I acknowledge the
                <span :class="dataCouponModal ? 'strikethrough' : ''">
                  {{ formatCurrencyUSD(is_onboard_price_modal) }}
                </span>
                <span v-if="dataCouponModal" class="discount-price" style="margin-left: 4px;">
                  {{ getTotalDue(is_onboard_price_modal, dataCouponModal) }}
                </span>
                setup fee for this agency has been paid and I agree to the 12-month contract and minimum spend requirement in Addendum C of the Service and Billing Agreement.
              </span>
              <span v-else class="agreement-charge-label-text">
                I agree to the 12-month contract and minimum spend requirement in Addendum C of the Service and Billing Agreement.
              </span>
            </base-checkbox>
          </div>
          <div class="pl-3 pr-3 pt-3">
            <a :href="`/service-billing-agreement${minSpend ? '?version=4' : ''}`" target="_blank" style="font-weight:bold;text-decoration:underline">Click here to view service and billing agreement page</a>
          </div>
          <div class="text-center" style="margin-top: 1rem;">
            <base-button :disabled="isLoadingServiceAgreement || agreeTermDisableModal" @click="agreeServiceAgreement()">
              <i v-if="isLoadingServiceAgreement" class="el-icon-loading" style="margin-right: 4px; font-size: 18px;"></i>
              I Read and Agree
            </base-button>
          </div>
      </el-dialog>
      <!-- SERVICE AGREEMENT MODAL -->

      <div v-if="popProcessing" v-loading.fullscreen.lock="popProcessing"
        element-loading-spinner="el-icon-loading"
        :element-loading-text="popProcessingTxt"
        >
      </div>
  </div>
</template>
<script>
import {Dropdown, DropdownMenu, DropdownItem, Switch, Card, Input, Progress, Checkbox, DatePicker, Dialog} from 'element-ui'
import { BaseNav, Modal, BetaBadge } from '@/components';
// import SidebarToggleButton from './SidebarToggleButton';
import ThemeButton from '@/components/ThemeButton';
import { extend } from "vee-validate";
import { required, confirmed, min } from "vee-validate/dist/rules";
import swal from 'sweetalert2';
import axios from 'axios';
import moment from "moment-timezone";
import { DOCUMENTS } from '../../shared/constants';

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

extend("required", required);
extend("confirmed", confirmed);
extend("min", min);
export default {
  components: {
    // SidebarToggleButton,
    //CollapseTransition,
    BaseNav,
    ThemeButton,
    Modal,
    BetaBadge,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Switch.name]: Switch,
    [Card.name]: Card,
    [Input.name]: Input,
    [Progress.name]: Progress,
    [Checkbox.name]: Checkbox,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
  },
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'Uncommon Reach',
      description: 'Sidebar title'
    },
    shortTitle: {
      type: String,
      default: 'UR',
      description: 'Sidebar short title'
    },
    logo: {
      type: String,
      default: '/img/icon-ur.png',
      description: 'Sidebar app logo'
    },
    backgroundColor: {
      type: String,
      default: 'red',
      validator: value => {
        let acceptedValues = [
          '',
          'vue',
          'blue',
          'green',
          'orange',
          'red',
          'primary'
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        'Sidebar background color (vue|blue|green|orange|red|primary)'
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these."
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  data() {
    return {
      selectedGroupCompany: '',
      modals: {
        updatepassword: false,
        twofactorauth: false,
        googleAuth: false,
        whitelist: false,
        openapi: false,
        billingAgreement:false,
        billingAgreementDirectPayment: false,
        directPayment: false,
        serviceAgreement: false,
      },
      isLoadingServiceAgreement: false,
      agreeTermBillingModal: false,
      agreeTermBillingModalError: false,
      agreementChargeModal: false,
      agreementChargeModalError: false,
      agreeTermDisableModal: true,
      _agreementScrollPoll: null,
      excludeOnBoardingModal: false,
      dataCouponModal: null,
      password: "",
      currpassword: "",
      confirmation: "",
      showPassword : false , 
      showCurentPassword : false,
      showConfirmPassword : false,
      btnResetPasswordText: "Change Password",
      btnOpenApiText: 'Generate Api Key',
      isSubmittingResetPassword: false,
      errorupdatepassword: false,
      two_factor_auth: false,
      two_factor_auth_type: null,
      isLoadingGetTwoFactorAuth: false,
      isLoadingSaveTwoFactorAuth: false,
      isLoadingGetGoogleTwoFactorAuth: false,
      isLoadingSaveGoogleTwoFactorAuth: false,
      isLoadingGenerateApiKey : false,
      qrCodeUrl: '',
      secretKey: '',

      optoutpath: process.env.VUE_APP_CDN,
      uploadFieldName: 'clientoptoutfile',
      currentStatus: null,
      supressionProgress: [],
      supressionDone: [],
      supressionInterval: '',
      optoutfileexist: false,
      whiteListClientID: '',

      checkbox_developer_api_paid: false,
      agree_developer_api_paid: '',
      openApiVisibility: {
        clientID: false,
        secretKey: false,
      },
      openApiClientID: '',
      openApiSecretKey: '',
      openApiBaseUrl: '',
      urlDownloadStateCity: 'https://emmspaces.nyc3.cdn.digitaloceanspaces.com/docs/state_city_list.csv',
      urlApiDocumentation: 'https://sitesettings-api-docs.vercel.app/',
      isLoadingMarketingServicesAgree: false,
      isLoadingMarketingServicesFeature: false,
      userData: {},

      agencyMinimumSpendStartDate: '2025-01-01',
      agencyMinimumSpendEndDate: '2025-02-01',
      agencyTotalWholesaleSpend: 0,
      agencyminimumPlatformSpend: 0,
      agencyminimumSpendBilling: 0,

      balanceDirectPayment: 0,
      amountDirectPayment: 0,
      customAmountDirectPayment: false,
      minimumAmountDirectPayment: 0,
      errMinimumAmountDirectPayment: false,
      totalAmountDirectPayment: 0,
      lastBalanceAmountDirectPayment: 0,
      paymentTypeDirectPayment: 'credit_card',
      isStopContinualDirectPayment: false,
      wordingStopContinualDirectPayment: '',
      isEnableTopupPrepaidDirectPayment: false,
      chooseAmount: [
        {
          id: 1,
          amount: 0,
        },
        {
          id: 2,
          amount: 250,
        },
        {
          id: 3,
          amount: 500,
        },
        {
          id: 4,
          amount: 1000,
        },
      ],
      activeIndexAmount: 0,
      fetchTransactionHistoryDirectPayment: false,
      dateTransactionHistoryDirectPayment: moment().format("YYYY-MM"),
      transactionHistoryDirectPayment: [],
      popProcessing: false,
      popProcessingTxt: 'Please wait, topup prepaid data wallet ....',
      minSpend: false,
      isMinSpendV2: false,
      isMinSpendV3: false,
      isMinSpendV4: false,
      googleAuthApps : [
        {
            id : 1 ,
            name : "Google Authenticator" , 
            linkAndroid : "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&pli=1" ,
            linkIphone : 'https://apps.apple.com/us/app/google-authenticator/id388497605'
        },
        {
            id : 2 ,
            name : "Authy" , 
            linkAndroid : "https://play.google.com/store/search?q=authy&c=apps" ,
            linkIphone : 'https://apps.apple.com/us/app/authy-mfa-2fa-authenticator/id6612031858'
        },
        {
            id : 3 ,
            name : "Microsoft Authenticator" , 
            linkAndroid : "https://play.google.com/store/search?q=Microsoft%20Authenticator&c=apps" ,
            linkIphone : 'https://apps.apple.com/us/app/microsoft-authenticator/id983156458'
        },
        {
            id : 4 ,
            name : "1Password" , 
            linkAndroid : "https://play.google.com/store/search?q=1Password&c=apps" ,
            linkIphone : 'https://apps.apple.com/us/app/1password-password-manager/id1511601750'
        },
        {
            id : 5 ,
            name : "Bitwarden" , 
            linkAndroid : "https://play.google.com/store/search?q=Bitwarden&c=apps" ,
            linkIphone : 'https://apps.apple.com/us/app/bitwarden-authenticator/id6497335175'
        },
        {
            id : 6 ,
            name : "Duo" , 
            linkAndroid : "https://play.google.com/store/apps/details?id=com.duosecurity.duomobile" ,
            linkIphone : 'https://apps.apple.com/us/app/duo-mobile/id422663827'
        }
      ] , 
    };
  },
  computed:{
    profileSetupLink() {
      return this.$global.menuLeadsPeek ? '/user/profile-setup-v1' : '/user/profile-setup';
    },
    isMobile() {
      return window.innerWidth <= 768;
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    dataWalletAgreementDialog: {
      get() {
        const result = this.modals.billingAgreementDirectPayment || this.$global.modals.billingAgreementDirectPayment
        // console.log('dataWalletAgreementDialog', {'result': result})
        return result;
      },
      set(value) {
        this.modals.billingAgreementDirectPayment = value
        this.$global.modals.billingAgreementDirectPayment = value
      }
    },
    serviceAgreementDialog: {
      get() {
        return this.modals.serviceAgreement || this.$global.modals.serviceAgreement;
      },
      set(value) {
        this.modals.serviceAgreement = value;
        this.$global.modals.serviceAgreement = value;
      }
    },
    is_onboard_price_modal() {
      return Number(this.$global.agency_onboarding_price) || 0;
    }
  },
  methods: {
    togglePassword() {
        this.showPassword = !this.showPassword
     },
      toggleCurrentPassword() {
        this.showCurentPassword = !this.showCurentPassword
    },
     toggleConfirmPassword() {
        this.showConfirmPassword = !this.showConfirmPassword
     },
    validateBetaFeature(type) {
      if(type == 'data_wallet') {
        if(!this.$global.betaFeature.b2b_module.is_beta || this.$global.betaFeature.b2b_module.apply_to_all_agency || this.$global.isBeta) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    showModalDeveloper(){
      this.checkbox_developer_api_paid = false;
      this.modals.billingAgreement = false;

      const userData = this.$store.getters.userData
      const payload = {
        company_id: userData.company_id
      }

      this.$store.dispatch('getMarketingServicesAgreement', payload).then(response => {
        if(response.is_marketing_services_agreement_developer == 'T'){
          this.popOpenApi()
        } else {
          const first_time_charge = response.first_time_charge;
          const minimum_spend_max = response.minimum_spend_max;
          const minimum_spend_amount_text = response.minimum_spend_amount_list.map(n => `$${n}`).join(', ');
          // console.log({first_time_charge,minimum_spend_max,minimum_spend_amount_text,'agree_developer_api_paid':this.agree_developer_api_paid});
          
          this.agree_developer_api_paid = `I agree that $${first_time_charge} will be immediately charged to the card on file, and the minimum spend will be $${minimum_spend_max} a month with a ramp up schedule of ${minimum_spend_amount_text}.`;
          this.modals.billingAgreement = true;
        }
      })
      .catch(error => {
        this.$notify({
          type: 'danger',
          message: error.message,
          icon: 'fas fa-bug'
        })
      });
      
    },
    agreedTermFeature(feature_id, feature_slug, feature_name) {
      this.isLoadingMarketingServicesFeature = true;
      const userData = this.$store.getters.userData
      const payload = {
        feature_id: feature_id,
        feature_slug: feature_slug,
        feature_name: feature_name,
        user_id: userData.id,
        is_marketing_services_agreement_feature: 'T',
        company_name: userData.company_name,
        company_id: userData.company_id,
        location_menu: this.$route.name,
      }

      this.$store.dispatch('marketingServicesAgreementFeature', payload).then(response => {
        this.isLoadingMarketingServicesFeature = false

        if(feature_slug == 'data_wallet') {
          this.modals.billingAgreementDirectPayment = false;
          this.$global.modals.billingAgreementDirectPayment = false;
          this.openPrepaidDirectPayment();
        }
      }).catch(error => {
        this.$notify({
          type: 'danger',
          message: 'Something went wrong, please try again later',
          icon: 'fas fa-bug'
        })
        this.isLoadingMarketingServicesFeature = false
      })
    },
    async agreeServiceAgreement() {
      const userData = this.$store.getters.userData;
      this.agreeTermBillingModalError = false;
      this.agreementChargeModalError = false;

      if (!this.agreeTermBillingModal) {
        this.agreeTermBillingModalError = true;
        this.$notify({
          type: 'danger',
          message: 'Please agree to the Service and Billing Agreement before continuing',
          icon: 'fas fa-bug',
        });
        return;
      }

      if ((this.minSpend || this.is_onboard_price_modal > 0) && userData.user_type != 'client' && !this.agreementChargeModal) {
        this.agreementChargeModalError = true;
        this.$notify({
          type: 'danger',
          message: 'You must agree to the contract agreement before continuing',
          icon: 'fas fa-bug',
        });
        return;
      }

      this.isLoadingServiceAgreement = true;

      try {
        const document = await this.$store.dispatch('getDocumentAgreementFile', {
          name: this.checkDocumentUrl(),
        });
        const fileUrl = document && document.url ? document.url : '';
        const fileDescription = fileUrl ? ' | fileUrl : ' + fileUrl : '';

        const payload = {
          userID: userData.id,
          action: "Service and Billing Agreement",
          desc: `The user has agreed to the Service and Billing Agreement. Name : ${userData.name} | Company Name : ${userData.company_name} | Email : ${userData.email} | userID : ${userData.customer_payment_id}${fileDescription} | Updated user id : ${userData.id} | Menu: Service Agreement Modal`,
          userIP: this.$store.getters.userData.ip_login,
          target_userID: userData.id,
        };

        await this.$store.dispatch('userLogSaved', { data: payload });
        try {
          await this.$store.dispatch('userServiceAgreementConfirm', {
            data: {
              userID: userData.id,
              document_type: this.checkDocumentUrl(),
            },
          });
        } catch (e) {
          // Optional: email agreement could fail; log tetap tersimpan, modal tetap ditutup
        }
        this.modals.serviceAgreement = false;
        this.$global.modals.serviceAgreement = false;
      } catch (error) {
        this.$notify({
          type: 'danger',
          message: 'Something went wrong, please try again later',
          icon: 'fas fa-bug',
        });
      }
      this.isLoadingServiceAgreement = false;
    },
    checkDocumentUrl(){
      const userData = this.$store.getters.userData;
      if(this.minSpend){
        return DOCUMENTS.MINIMUM_SPEND_V4;
      } else if (userData.user_type != 'client'){
        return DOCUMENTS.DEFAULT_AGENCY;
      } else if (userData.user_type == 'client'){
        return DOCUMENTS.DEFAULT_CLIENT;
      } else {
        return ''
      }
    },
    onIframeLoadAgreement() {
      const iframe = this.$refs.iframeRefAgreement;
      if (!iframe) return;
      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDoc) {
          const style = iframeDoc.createElement('style');
          style.innerHTML = '.full-page > .content { padding-top: 0 !important; padding-bottom: 40px !important; }';
          iframeDoc.head.appendChild(style);
        }

        iframeDoc.addEventListener('scroll', () => {
          this._checkAgreementScroll();
        }, { passive: true });

        this.startAgreementScrollPoll();
      } catch (error) {
        console.warn('Service agreement iframe scroll: cross-origin restriction.');
      }
    },
    _checkAgreementScroll() {
      try {
        const iframe = this.$refs.iframeRefAgreement;
        if (!iframe) return false;
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        const iframeWin = iframe.contentWindow;
        const docEl = iframeDoc.documentElement;
        const scrollHeight = docEl.scrollHeight;
        const clientHeight = docEl.clientHeight;
        const scrollTop = docEl.scrollTop || iframeWin.pageYOffset || 0;

        if (scrollHeight <= clientHeight + 10) {
          this.agreeTermDisableModal = false;
          return true;
        }
        if (scrollTop + clientHeight >= scrollHeight - 10) {
          this.agreeTermDisableModal = false;
          return true;
        }
      } catch (_) {}
      return false;
    },
    startAgreementScrollPoll() {
      if (this._agreementScrollPoll) {
        clearInterval(this._agreementScrollPoll);
        this._agreementScrollPoll = null;
      }
      let count = 0;
      const maxPolls = 20;
      this._agreementScrollPoll = setInterval(() => {
        count++;
        if (this._checkAgreementScroll() || count >= maxPolls) {
          clearInterval(this._agreementScrollPoll);
          this._agreementScrollPoll = null;
        }
      }, 500);
    },
    getDiscountAmount(price, coupon) {
      const priceNum = Number(price);
      if (!coupon || !coupon.type || coupon.value == null) return 0;
      if (coupon.type === 'percentage') {
        return priceNum * (Number(coupon.value) / 100);
      }
      if (coupon.type === 'fixed') {
        return Math.min(Number(coupon.value), priceNum);
      }
      return 0;
    },
    getTotalDue(price, coupon) {
      const discount = this.getDiscountAmount(price, coupon);
      const total = Number(price) - discount;
      return total.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    },
    formatCurrencyUSD(price) {
      return Number(price).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    },
    agreedtermofbilling(){
      if(!this.$global.systemUser && !this.checkbox_developer_api_paid) {
        this.$notify({
          type: 'danger',
          message: 'Please click agree before you continue',
          icon: 'fas fa-bug'
        })
        return false;
      }

      this.isLoadingMarketingServicesAgree = true;
      const userData = this.$store.getters.userData
      const payload = {
        user_id: userData.id,
        is_marketing_services_agreement_developer: 'T',
        company_name: userData.company_name,
        company_id: userData.company_id,
        location_menu: this.$route.name,
        document_type: this.checkDocumentUrl(),
      }

      this.$store.dispatch('marketingServicesAgreement', payload).then(response => {
        this.$notify({
          type: 'success',
          message: response.message,
          icon: 'tim-icons icon-bell-55'
        })
        this.modals.billingAgreement = false
        this.isLoadingMarketingServicesAgree = false
        this.popOpenApi()
      }).catch(error => {
        this.$notify({
          type: 'danger',
          message: error.message,
          icon: 'fas fa-bug'
        })
        this.isLoadingMarketingServicesAgree = false
      })
      // API call For tracking
     
    },
    apiDocumentation() {
      window.open(this.urlApiDocumentation, '_blank');
    },
    downloadStateCity() {
      document.location = this.urlDownloadStateCity;
    },
    copyInputOpenApi(inputName) {
      const textarea = document.createElement('textarea'); // Membuat elemen textarea sementara 
      
      if(inputName == 'client_id') {
        textarea.value = this.openApiClientID; // Mengisi textarea dengan nilai yang akan disalin
      }
      else if(inputName == 'secret_key') {
        textarea.value = this.openApiSecretKey; // Mengisi textarea dengan nilai yang akan disalin
      }

      document.body.appendChild(textarea); // Menambahkan textarea ke DOM
      textarea.select(); // Memilih teks dalam textarea
      document.execCommand('copy'); // Menyalin teks ke clipboard
      document.body.removeChild(textarea); // Menghapus textarea dari DOM

      
      this.$notify({
        type: 'success',
        message: `${(inputName == 'client_id' ? 'Client ID' : 'Secret Key')} copied to the clipboard!`,
        icon: 'tim-icons icon-bell-55'
      })
    },
    generateAuthenticateOpenApi() {
      this.isLoadingGenerateApiKey = true
      let companyID = ""
      let email = this.$store.getters.userData.email;

      companyID = this.$store.getters.userData.company_id;

      this.$store.dispatch('generateAuthenticateOpenApi', {
        companyID,
        email
      })
      .then(response => {
        if(response.data.status == 'success') {
          this.openApiClientID = response.data.user.client_id;
          this.openApiSecretKey = response.data.user.secret_key;
          this.isLoadingGenerateApiKey = false
          this.$notify({
            type: 'success',
            message: 'api key successfully generated!',
            icon: 'tim-icons icon-bell-55'
          })
        }
      })
      .catch(error => {
        console.error(error);
        this.isLoadingGenerateApiKey = false
        swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error"
        });
          this.isLoadingGenerateApiKey = false
      });
    },
    toggleInputOpenApi(inputName) {
      if(inputName == 'client_id') {
        this.openApiVisibility.clientID = !this.openApiVisibility.clientID;
      }
      else if(inputName == 'secret_key') {
        this.openApiVisibility.secretKey = !this.openApiVisibility.secretKey;
      }
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      const file = fileList[0];
      const validCSV = /\.(csv)$/i.test(file.name);

      if (!validCSV) {
          this.$notify({
              type: 'danger',
              message: 'Invalid file format. This upload only supports CSV files.',
              icon: 'fas fa-bug'
          })

          return;
      }

      // append the files to FormData
      Array
      .from(Array(fileList.length).keys())
      .map(x => {
        const fileMapping = fileList[x];
        const cleanFileName = fileMapping.name
            .replace(/\s+/g, "_")
            .replace(/[^a-zA-Z0-9_.-]/g, "")
            .toLowerCase();

        const newFile = new File([fileMapping], cleanFileName, { type: fileMapping.type });

        formData.append(fieldName, newFile, cleanFileName);
      });

      let campaignType = this.$store.getters.userData.user_type == 'client' ? 'client' : 'agency';
      formData.append("ClientCompanyID",this.whiteListClientID);
      formData.append("campaigntype",campaignType);
      // save it
      this.save(formData);
    },
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      clearTimeout(this.supressionTimeout);
      clearInterval(this.supressionInterval);

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          'Access-Control-Allow-Origin' : '*',
        }
      };

      axios.post(process.env.VUE_APP_APISERVER_URL + '/api/tools/optout-client/upload', formData, config)
      .then(response => {
        //console.log(response.data);
        if(response.data.result == 'success') {
          this.currentStatus = STATUS_SUCCESS;
          this.reset();
          this.checkStatusFileUpload();
        }else{
          this.currentStatus = STATUS_FAILED;
          this.reset();
        }
      })
      .catch(error => {
        //console.log(error);
        this.currentStatus = STATUS_FAILED;
        this.reset();
        //reject(error)
      })
      
      /* UPLOAD FILE */
      // try 
      // {
      //   const response = await axios.post(process.env.VUE_APP_APISERVER_URL + '/api/tools/optout-client/upload', formData, config)
        
      //   if (response.data.result == 'success') {
      //     this.currentStatus = STATUS_SUCCESS;
      //     this.checkStatusFileUpload();
      //     setTimeout(() => {
      //         this.reset();
      //     }, 2000);
      //   } else {
      //     this.currentStatus = STATUS_FAILED;
      //     setTimeout(() => {
      //         this.reset();
      //     }, 2000);
      //   }
      // } 
      // catch(error) 
      // {
      //   console.error(error);
      //   this.currentStatus = STATUS_FAILED;
      //   setTimeout(() => {
      //       this.reset();
      //   }, 2000);
      // }
      /* UPLOAD FILE */
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
      this.uploadFieldName = 'clientoptoutfile';
      $('input[type="file"]').val(null);
    },
    purgeSuppressionList(action) {
      if (this.$store.getters.userData.user_type != 'client') {
        action = 'agency';
      }
      swal.fire({
        title: 'Record Purge Confirmation',
        text: "Are you sure you want to purge existing records?",
        showCancelButton: true,
        customClass: {
            confirmButton: 'btn btn-default btn-fill',
            cancelButton: 'btn btn-danger btn-fill'
        },
        buttonsStyling: false,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          this.supressionDone = [];
          // Perform the deletion
          this.$store.dispatch('purgeSuppressionList', {
            paramID: this.whiteListClientID,
            campaignType: action,
          }).then(response => {
            if (response.result === 'success') {
              swal.fire({
                icon: 'success',
                title: response.title,
                text: response.msg,
                confirmButtonText: 'OK'
              });
            } else {
              swal.fire({
                icon: 'error',
                title: response.title,
                text: response.msg,
                confirmButtonText: 'OK'
              });
            }
          }).catch(error => {
            swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'There was an error processing your request.',
              confirmButtonText: 'OK'
            });
          });
        }
      });
    },
    popOpenApi() {
      this.openApiVisibility.clientID = false;
      this.openApiVisibility.secretKey = false;

      let companyID = this.$store.getters.userData.company_id;
      // let userID = this.$store.getters.userData.id;

      this.$store.dispatch('getAuthenticateOpenApi', {
        companyID,
      })
      .then(response => {
        this.modals.openapi = true;

        if(response.data.status == 'success') {
          this.openApiBaseUrl = response.data.base_url;
          this.openApiClientID = response.data.client_id;
          this.openApiSecretKey = response.data.secret_key;
        }
      })
      .catch(error => {
        // this.modals.openapi = true;
        swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response.data.message,
        });
      });
    },
    popWhiteList() {
      this.whiteListClientID = this.$store.getters.userData.company_id;
      this.modals.whitelist = true;
      this.checkStatusFileUpload();
    },
    checkStatusFileUpload() {
      clearInterval(this.supressionInterval);

      /** START CHECK IF THERE IS ANYTHING NOT DONE */
      let campaignType = this.$store.getters.userData.user_type == 'client' ? 'client' : 'agency';
        this.$store.dispatch('jobProgress', {
          companyId: this.whiteListClientID,
          campaignType: campaignType,
        })
        .then(response => {
          this.supressionProgress = response.data.jobProgress;
          this.supressionDone = response.data.jobDone;
          
          if(this.supressionProgress.length > 0) {
              this.supressionTimeout = setTimeout(() => {
                  this.supressionInterval = setInterval(() => {
                      this.$store.dispatch('jobProgress', {
                        companyId: this.whiteListClientID,
                        campaignType: campaignType,
                      })
                      .then(response => {
                          this.supressionProgress = response.data.jobProgress;
                          this.supressionDone = response.data.jobDone;
                          
                          if(this.supressionProgress.length == 0) {
                              clearTimeout(this.supressionTimeout);
                              clearInterval(this.supressionInterval);
                          }
                      })
                      .catch(error => {
                          console.error(error);
                      })
                  }, 2000);
              }, 2000);
          } else {
              clearTimeout(this.supressionTimeout);
              clearInterval(this.supressionInterval); 
          }
        })
        .catch(error => {
          console.error(error);
        })
      /** START CHECK IF THERE IS ANYTHING NOT DONE */
    },
    /* METHOD FOR EXCLUSION LIST */

    onGroupChange: function onGroupChange(event) {
      //alert(this.$global.selectsGroupCompany.companyGroupSelected);
      localStorage.setItem('companyGroupSelected',event.target.value);
      this.$router.go();
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    closeSidebar() {
      if (this.$sidebar && this.isMobile) {
        this.$sidebar.closeSidebar();
      }
    },
    popupdatepasswordsuccess() {
      swal.fire({
        title: 'Change Password',
        text: 'your password has been updated!',
        timer: 2000,
        showConfirmButton: false,
        icon: 'success'
      });
    },
    ProcessResetPassword() {
     if (this.password.length < 8) {
            this.$notify({
                type: 'danger',
                message: 'password must be at least 8 characters long.',
                icon: 'fas fa-exclamation-triangle'
              });
            return false;
     }
      this.btnResetPasswordText = 'Change Password';
      this.isSubmittingResetPassword = true;

      var userdata = this.$store.getters.userData

      this.$store.dispatch('updatePass', {
        usrID: userdata.id,
        newpassword: this.password,
        currpassword: this.currpassword,
      })
        .then(response => {
          if (response.result == 'success') {
            this.modals.updatepassword = false;
            this.popupdatepasswordsuccess();
          } else {
            this.isSubmittingResetPassword = false;
            this.errorupdatepassword = true;
          }

        }, error => {
          this.isSubmittingResetPassword = false;
          this.errorupdatepassword = true;

        })

    },
    popResetPassword() {
      this.password = "";
      this.confirmation = "";
      this.btnResetPasswordText = "Change Password";
      this.isSubmittingResetPassword = false;
      this.errorupdatepassword = false;
      this.modals.updatepassword = true;
    },
    logout() {
      localStorage.removeItem('companyGroupSelected');
      localStorage.removeItem('subdomainAgency');
      localStorage.removeItem('rootcomp');
      localStorage.removeItem('isRegisterAccount');
      this.$global.selectsGroupCompany.companyGroupList = null;
      this.$store.dispatch('destroyToken')
      .then(response => {
        //this.$router.push({ name: 'Login' })
        window.document.location = '/login';
      })
    },
    async onOpenModalTwoFactorAuth(){
      const userData = this.$store.getters.userData
      this.isLoadingGetTwoFactorAuth = true
      await this.$store.dispatch('getSettingTwoFactorAuth', {
        userId: userData.id,
      }).then(response => {
        this.two_factor_auth = response.two_factor_auth
        this.two_factor_auth_type = response.two_factor_auth_type
        this.modals.twofactorauth = true;
      }, error => {
        this.$notify({
          type: 'primary',
          message: error.message,
          icon: 'fas fa-bug'
        })
      })
      this.isLoadingGetTwoFactorAuth = false
    },
    onCloseModalTwoFactorAuth(){
      this.two_factor_auth = false
      this.two_factor_auth_type = null
      this.modals.twofactorauth = false;
    },
    async onClickTwoFactorAuth(){
      if(this.two_factor_auth_type == 'google'){
          this.onCloseModalTwoFactorAuth();
          this.getGoogleTfa();
          this.modals.googleAuth = true
      } else {
        this.isLoadingSaveTwoFactorAuth = true
        const userData = this.$store.getters.userData
  
        const payload = {
          userId: userData.id,
          two_factor_auth: this.two_factor_auth,
          two_factor_auth_type: this.two_factor_auth_type,
        }
  
        await this.$store.dispatch('settingTwoFactorAuth', payload)
        .then(response => {
          this.$notify({
              type: 'success',
              message: response.message,
              icon: 'far fa-save'
          });
        }, error => {
          this.$notify({
            type: 'danger',
            message: error.message,
            icon: 'fa fa-save'
          })
        })
        this.isLoadingSaveTwoFactorAuth = false
        this.onCloseModalTwoFactorAuth()
      }
    },
    onHandleSelectTwoFactorAuth(value){
      if(this.two_factor_auth_type == value){
        this.two_factor_auth = false,
        this.two_factor_auth_type = null
      } else {
        this.two_factor_auth = true
        this.two_factor_auth_type = value
      }
    },
    async onHandleCancelGoogleTwoFactorAuth(){
      await this.onOpenModalTwoFactorAuth();
      this.modals.googleAuth = false;
    },
    async getGoogleTfa(){
      const userData = this.$store.getters.userData
      this.isLoadingGetGoogleTwoFactorAuth = true
      await this.$store.dispatch('getGoogleTfa', {
        userId: userData.id,
        companyId: userData.company_id,
      }).then(response => {
        let qrCodeXml = response.qrCodeUrl;
              const stringToRemoveFront = '<?xml version="1.0" encoding="UTF-8"?>\n';
              const stringToRemoveBack = '\n';

              if (typeof qrCodeXml === 'string') {
                  if (qrCodeXml.startsWith(stringToRemoveFront)) {
                      qrCodeXml = qrCodeXml.slice(stringToRemoveFront.length);
                  }
                  
                  if (qrCodeXml.endsWith(stringToRemoveBack)) {
                      qrCodeXml = qrCodeXml.slice(0, -stringToRemoveBack.length);
                  }
              }

        this.qrCodeUrl = 'data:image/svg+xml;base64,' + btoa(qrCodeXml);
        this.secretKey = response.secretKey
      }, error => {
        this.$notify({
            type: 'danger',
            message: error.message,
            icon: 'fa fa-save'
          })
      })
      this.isLoadingGetGoogleTwoFactorAuth = false
    },
    async onClickSaveGoogle(){
      const userData = this.$store.getters.userData
      this.isLoadingSaveGoogleTwoFactorAuth = true
  
      const payload = {
        userId: userData.id,
        two_factor_auth: true,
        two_factor_auth_type: 'google',
        secretKey: this.secretKey,
      }

      await this.$store.dispatch('settingTwoFactorAuth', payload)
        .then(response => {
          this.$notify({
              type: 'success',
              message: response.message,
              icon: 'far fa-save'
          });
        }, error => {
          this.$notify({
            type: 'danger',
            message: error.message,
            icon: 'fa fa-save'
          })
        })
        this.isLoadingSaveGoogleTwoFactorAuth = false
        this.modals.googleAuth = false
        this.onCloseModalTwoFactorAuth()
    },
    openPrepaidDirectPayment() {
      this.fetchTransactionHistoryDirectPayment = true;
      this.amountDirectPayment = 0;
      // console.log('openPrepaidDirectPayment', { 'this.amountDirectPayment #1 = ': this.amountDirectPayment })
      this.balanceDirectPayment = 0;
      this.totalAmountDirectPayment = 0;
      this.isStopContinualDirectPayment = false;
      this.transactionHistoryDirectPayment = [];
      this.dateTransactionHistoryDirectPayment = moment().format("YYYY-MM");
      this.isEnableTopupPrepaidDirectPayment = false;
      this.activeIndexAmount = 0;

      this.$store.dispatch('getPrepaidDirectPayment', {
        company_id: this.userData.company_id,
        date: this.dateTransactionHistoryDirectPayment
      })
      .then(response => {
        // console.log(response);
        this.fetchTransactionHistoryDirectPayment = false;
        this.customAmountDirectPayment = (response.custom_amount == 'T') ? true : false;
        this.amountDirectPayment = response.amount; // (response.custom_amount == 'F') ? (response.amount >= 250 ? response.amount : 250) : response.amount 
        // console.log('openPrepaidDirectPayment', { 'this.amountDirectPayment #2 = ': this.amountDirectPayment })
        this.balanceDirectPayment = response.balance_amount;
        this.totalAmountDirectPayment = response.total_amount;
        this.lastBalanceAmountDirectPayment = response.last_balance_amount;
        this.isStopContinualDirectPayment = (response.stop_continual == 'T') ? true : false;
        this.wordingStopContinualDirectPayment = (this.isStopContinualDirectPayment === true) ? 'Continual Topup' : 'Stop Continual Topup';
        this.transactionHistoryDirectPayment = response.transaction_history;
        this.blurInputAmountDirectPayment();
        this.keyupInputAmountDirectPayment();
        this.modals.directPayment = true;
        this.isEnableTopupPrepaidDirectPayment = response.is_enable_topup_prepaid_direct_payment;
        this.agencyMinimumSpendStartDate = response.agencyMinimumSpendStartDate;
        this.agencyMinimumSpendEndDate = response.agencyMinimumSpendEndDate;
        this.agencyTotalWholesaleSpend = response.agencyTotalWholesaleSpend;
        this.agencyminimumPlatformSpend = response.agencyMinimumPlatformSpend;
        this.agencyminimumSpendBilling = response.agencyMinimumSpendBilling;
      })
      .catch(error => {
        console.error(error);
        this.fetchTransactionHistoryDirectPayment = false;
        this.modals.directPayment = true;
      });
    },
    stopContinualTopupDirectPayment() {
      if(Number(this.amountDirectPayment) <= 0) {
        return;
      }

      this.$store.dispatch('stopContinualTopupDirectPayment', {
        company_id: this.userData.company_id,
        stop_continual: this.isStopContinualDirectPayment
      })
      .then(response => {
        // console.log(response);
        this.$notify({
          type: 'success',
          message: response.message,
          icon: 'fa fa-save'
        });
        this.isStopContinualDirectPayment = response.stop_continual == 'T' ? true : false;
        this.wordingStopContinualDirectPayment = (this.isStopContinualDirectPayment === true) ? 'Continual Topup' : 'Stop Continual Topup';
        this.keyupInputAmountDirectPayment();
      })
      .catch(error => {
        console.error(error);
      })
    },
    onActiveIndexAmount(value) {
      if (!this.customAmountDirectPayment) {
        this.amountDirectPayment = value.amount;
        // console.log('onActiveIndexAmount', { 'this.amountDirectPayment #3 = ': this.amountDirectPayment })
        this.activeIndexAmount = value.id;
      } else {
        this.activeIndexAmount = 0;
      }
    },
    restrictInput(event) {
      const input = event.target.value;
      const char = event.key;

      if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
          return; 
      }

      if (!char.match(/[0-9]/) && char !== '.') {
          event.preventDefault();
      }

      // Allow only one period
      if (char === '.' && input.includes('.')) {
        event.preventDefault();
      }
    },
    blurInputAmountDirectPayment() {
      // console.log('blurInputAmountDirectPayment', {'this.amountDirectPayment': this.amountDirectPayment,'this.minimumAmountDirectPayment': this.minimumAmountDirectPayment,});
      if(Number(this.amountDirectPayment) < Number(this.minimumAmountDirectPayment)) {
        this.amountDirectPayment = this.minimumAmountDirectPayment;
        this.activeIndexAmount = 0;
        // console.log('blurInputAmountDirectPayment', { 'this.amountDirectPayment #4 = ': this.amountDirectPayment })
      } 
      this.errMinimumAmountDirectPayment = false;
    },
    keyupInputAmountDirectPayment() {
      if(Number(this.amountDirectPayment) < Number(this.minimumAmountDirectPayment)) {
        this.errMinimumAmountDirectPayment = true;
      } else {
        this.errMinimumAmountDirectPayment = false;
      }

      const chooseAmount =  this.chooseAmount.find(item => item.amount == this.amountDirectPayment);
      this.activeIndexAmount = chooseAmount ? chooseAmount.id : 0;
      // console.log('keyupInputAmountDirectPayment', {'this.minimumAmountDirectPayment': this.minimumAmountDirectPayment,'this.amountDirectPayment': this.amountDirectPayment,'this.chooseAmount': this.chooseAmount,'chooseAmount': chooseAmount,'this.activeIndexAmount': this.activeIndexAmount,});
    },
    changeDateTransactionHistoryDirectPayment(newValue) {
      this.fetchTransactionHistoryDirectPayment = true;
      this.transactionHistoryDirectPayment = [];
      this.dateTransactionHistoryDirectPayment = (newValue != null) ? moment(newValue).format("YYYY-MM") : '';

      this.$store.dispatch('getTransactionHistoryDirectPayment', {
        company_id: this.userData.company_id,
        date: this.dateTransactionHistoryDirectPayment
      })
      .then(response => {
        this.fetchTransactionHistoryDirectPayment = false;
        this.transactionHistoryDirectPayment = response.transaction_history;
      })
      .catch(error => {
        this.fetchTransactionHistoryDirectPayment = false;
        console.error(error);
      })
    },
    downloadTransactionHistoryDirectPayment() {
      const company_id = this.userData.company_id;
      const date = (this.dateTransactionHistoryDirectPayment != null && this.dateTransactionHistoryDirectPayment != '')  ? this.dateTransactionHistoryDirectPayment : '';
      document.location = `${process.env.VUE_APP_DATASERVER_URL}/configuration/agencies/prepaid/download-transaction-history-direct-payment/${company_id}/${date}` ;
    },
    getColorTransaction(type) {
      switch(type) {
        case 'topup': return '';
        case 'charge': return 'rgb(147, 2, 30)';
        case 'refund_agency': return 'rgb(147, 2, 30)';
        default: return 'rgb(0, 81, 97)';
      }
    },
    
    saveOrChangePrepaidDirectPayment() {
      if (Number(this.amountDirectPayment) <= 0) { // jika amount nya 0, maka save saja
        this.savePrepaidDirectPayment();
      } else { // jika amount lebih besar dari 0, maka charge saja
        this.chargePrepaidDirectPayment();
      }
    },

    // save data wallet
    savePrepaidDirectPayment() { // swal
      const title = 'Are you sure you want to save your Data Wallet settings?';
      const btnOkName = 'I agree';

      let html = "You're about to update your Data Wallet settings. Since your selected amount is $0, this action will not charge your credit card or trigger any top-up. These changes will take effect immediately after saving.";
      html += "<br><br>"
      html += "Please make sure the configuration is correct before proceeding.";

      swal.fire({
        title: title,
        html: html,
        icon: '',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-default btn-fill',
          cancelButton: 'btn btn-danger btn-fill'
        },
        confirmButtonText: btnOkName,
        buttonsStyling: false
      })
      .then(result => {
        if(result.value) {
          this.processSavePrepaidDirectPayment();
        }
      });
    },
    processSavePrepaidDirectPayment() { // process
      if(Number(this.amountDirectPayment) < Number(this.minimumAmountDirectPayment)) {
        this.$notify({
          type: 'danger',
          message: `The minimum amount is $${this.minimumAmountDirectPayment}`,
          icon: 'fa fa-bug'
        });
        return;
      }

      this.popProcessing = true;
      
      this.$store.dispatch('savePrepaidDirectPayment', {
        company_id: this.userData.company_id,
        amount: this.amountDirectPayment,
        custom_amount: this.customAmountDirectPayment,
        stop_continual: this.isStopContinualDirectPayment,
      })
      .then(response => {
        // console.log(response);
        this.$notify({
          type: 'success',
          message: response.message,
          icon: 'fa fa-save'
        });
        this.popProcessing = false;
        this.modals.directPayment = false;
      })
      .catch(error => {
        console.error(error);
        this.popProcessing = false;
        this.modals.directPayment = false;
      })
    },
    // save data wallet

    // charge data wallet
    chargePrepaidDirectPayment() { // swal
      if(Number(this.amountDirectPayment) < Number(this.minimumAmountDirectPayment)) {
        this.$notify({
          type: 'danger',
          message: `The minimum amount is $${this.minimumAmountDirectPayment}`,
          icon: 'fa fa-bug'
        });
        return;
      }

      const title = 'Are you sure you want to topup data wallet?';
      const btnOkName = 'I agree';

      let html = `You will top up your balance by $${this.amountDirectPayment} using a credit card.`;
      if(!this.isStopContinualDirectPayment) {
        html += `The card will automatically charge back the balance when the balance reaches 10% of the setup your amount`;
      }
      html += "<br><br>"
      html += "I understand that the purchase of a prepaid amount is non-refundable.";

      swal.fire({
        title: title,
        html: html,
        icon: '',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-default btn-fill',
          cancelButton: 'btn btn-danger btn-fill'
        },
        confirmButtonText: btnOkName,
        buttonsStyling: false
      })
      .then(result => {
        if(result.value) {
          this.processChargePrepaidDirectPayment();
        }
      });
    },
    processChargePrepaidDirectPayment() { // process
      this.popProcessing = true;

      this.$store.dispatch('chargePrepaidDirectPayment', {
        company_id: this.userData.company_id,
        amount: this.amountDirectPayment,
        custom_amount: this.customAmountDirectPayment,
        stop_continual: this.isStopContinualDirectPayment,
        ip_user: this.$store.getters.userData.ip_login,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        payment_type: this.paymentTypeDirectPayment
      })
      .then(response => {
        // console.log(response);
        this.popProcessing = false;
        this.modals.directPayment = false;
        
        const result = (typeof(response.result) != 'undefined') ? response.result : ''; 
        const message = (typeof(response.message) != 'undefined') ? response.message : '';
        if(result == 'success') {
          this.$notify({
            type: 'success',
            message: message,
            icon: 'fa fa-save'
          });
        }
      })
      .catch(error => {
        console.error(error);
        this.popProcessing = false;
        this.modals.directPayment = false;

        const result = (typeof(error.response.data.result) != 'undefined') ? error.response.data.result : ''; 
        const message = (typeof(error.response.data.message) != 'undefined') ? error.response.data.message : '';
        if(result == 'error' || result == 'failed') {
          this.$notify({
            type: 'danger',
            message: message,
            icon: 'fa fa-bug'
          });
        }
      })
    },
    // charge data wallet

    showModalPrepaidDirectPayment() {
      if(this.$global.betaFeature.data_wallet.is_beta && (this.$global.betaFeature.data_wallet.apply_to_all_agency || this.$global.isBeta)) { // jika beta dan status
        const userData = this.$store.getters.userData
        const payload = {
          user_id: userData.id,
          feature_id: this.$global.betaFeature.data_wallet.id
        }

        this.$store.dispatch('getMarketingServicesAgreementFeature', payload).then(response => {
          if(response.status == 'T') {
            this.openPrepaidDirectPayment();
          } else {
            this.modals.billingAgreementDirectPayment = true;
          }
        }).catch(error => {
          this.$notify({
            type: 'danger',
            message: 'Something went wrong, please try again later',
            icon: 'fas fa-bug'
          })
        })
      } else {
        this.openPrepaidDirectPayment();
      }
    },
    checkMinSpend(){
        const userData = this.$store.getters.userData

        this.$store.dispatch('GetRoleList', {
          companyID: userData.company_id,
          getType:'getrolemodule',
          roleID: userData.role_id,
          usrID: userData.id,
        }).then(response => {
            this.minSpend = response.minspend_setting && response.minspend_setting.status;
        },error => {
            console.log(error);
        });
    },
    checkMinSpendLatest(){
      const userData = this.$store.getters.userData
      this.$store.dispatch('getMinSpendLatest', {
        company_id: userData.company_id || '',
      }).then(response => {
          this.isMinSpendV2 = response.isAgreementV2
          this.isMinSpendV3 = response.isAgreementV3
          this.isMinSpendV4 = response.isAgreementV4
      },error => {
          console.log(error);
      });
    },
  },
  mounted() {
    const userData = this.$store.getters.userData
    this.userData = userData;
    this.reset();

    if(this.$store.state.userData.company_logo != null && this.$store.state.userData.company_logo != '') {
        document.getElementById('companylogosidebar').src = this.$store.state.userData.company_logo
    }else{
        if (this.$store.state.userData.user_type == 'client' && this.$store.state.userData.companyparentlogo != null && this.$store.state.userData.companyparentlogo != '') {
           document.getElementById('companylogosidebar').src = this.$store.state.userData.companyparentlogo;
        }else{
          document.getElementById('companylogosidebar').src = '/img/logoplaceholder.png'
        }
    }
    
    this.selectedGroupCompany = '';
    if (localStorage.getItem('companyGroupSelected') != null) {
       this.selectedGroupCompany = localStorage.getItem('companyGroupSelected');
    }
    //console.log(this.$global.selectsGroupCompany.companyGroupList);
    if (this.$global.selectsGroupCompany.companyGroupList == null || this.$global.selectsGroupCompany.companyGroupList.length == 0) {
      const userData = this.$store.getters.userData;
      const companyID = (userData.user_type != 'client') ? userData.company_id : userData.company_parent;
      /** GET COMPANY GROUP */
      this.$store.dispatch('GetCompanyGroup', {
        companyID: companyID,
        userModule: 'LeadsPeek',
      }).then(response => {
          //console.log(response.length);
          if (response.result == 'success') {
            this.$global.selectsGroupCompany.companyGroupList = response.params;
            this.$global.selectsGroupCompany.companyGroupList.unshift({'id':'','group_name':'View All'});
            
            if (localStorage.getItem('companyGroupSelected') == null && response.params.length > 1) {
              localStorage.setItem('companyGroupSelected',response.params[1].id);
              this.selectedGroupCompany = response.params[1].id;
            }
          }
      },error => {
          
      });
      /** GET COMPANY GROUP */
    }

    if(userData.user_type != 'client'){
      this.checkMinSpend();
      this.checkMinSpendLatest();
    }
  },
  watch: {
    serviceAgreementDialog(val) {
      if (val) {
        this.agreeTermDisableModal = true;
        this.agreeTermBillingModal = false;
        this.agreementChargeModal = false;
        this.agreeTermBillingModalError = false;
        this.agreementChargeModalError = false;
        this.$nextTick(() => {
          this.startAgreementScrollPoll();
        });
      } else {
        if (this._agreementScrollPoll) {
          clearInterval(this._agreementScrollPoll);
          this._agreementScrollPoll = null;
        }
      }
    },
    'modals.whitelist': function(newValue) {
      if(!newValue) {
        this.supressionProgress = [];
        clearTimeout(this.supressionTimeout);
        clearInterval(this.supressionInterval);
      }
    },
    customAmountDirectPayment(newValue) {
      this.minimumAmountDirectPayment = newValue ? 2500 : 0;
      // console.log('customAmountDirectPayment', {'newValue': newValue,'this.amountDirectPayment': this.amountDirectPayment,'this.minimumAmountDirectPayment': this.minimumAmountDirectPayment,})
      if(!newValue || Number(this.amountDirectPayment) < Number(this.minimumAmountDirectPayment)) {
        this.amountDirectPayment = this.minimumAmountDirectPayment;
        // console.log('customAmountDirectPayment', { 'this.amountDirectPayment #5 = ': this.amountDirectPayment })
        this.keyupInputAmountDirectPayment();
      }
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>

<style scoped>
.el-loading-spinner .el-loading-text {
  color: #fff;
}
.info-panel {
  background-color: #eef6ff !important; /* light blue */
  border: 1px solid #d6e9ff;
}
.info-panel .el-card__body {
  background-color: transparent;
  padding-top: 14px;
  padding-bottom: 14px;
}
.info-panel p { margin: 0 0 4px; }
.info-panel p:last-child { margin-bottom: 0; }
.notes-section {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(214, 233, 255, 0.5);
  font-size: 12px;
  line-height: 1.5;
  color: #555;
}
.notes-section p {
  margin: 0 0 12px;
  color: #555;
}
.notes-section p:last-child {
  margin-bottom: 0;
}
.notes-section strong {
  font-weight: 700;
  color: #333;
}
.strikethrough {
  text-decoration: line-through;
}
.discount-price {
  font-weight: 600;
  color: #28a745;
}
/* Agar teks label agreement tidak terpotong di tengah kata saat wrap */
.agreement-charge-label-wrap {
  word-break: normal;
  overflow-wrap: break-word;
}
.agreement-charge-label-wrap .agreement-charge-label-text,
.agreement-charge-label-wrap ::v-deep .form-check-label {
  word-break: normal;
  overflow-wrap: break-word;
  white-space: normal;
}
</style>

<style>
.button-save-or-charge-prepaid-direct-payment {
  width: 60% !important;
}
@media (min-width: 400px) {
  .button-save-or-charge-prepaid-direct-payment {
    width: 50% !important;
  }
}
@media (min-width: 500px) {
  .button-save-or-charge-prepaid-direct-payment {
    width: 40% !important;
  }
}
@media (min-width: 648px) {
  .button-save-or-charge-prepaid-direct-payment {
    width: 25% !important;
  }
}
@media (min-width: 768px) {
  .button-save-or-charge-prepaid-direct-payment {
    width: 20% !important;
  }
}
@media (min-width: 1024px) {
  .button-save-or-charge-prepaid-direct-payment {
    width: 15% !important;
  }
}

@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}

@media (min-width : 200px) {
  .footer-section-developer-agreement {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media (min-width : 928px) {
   .footer-section-developer-agreement {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1.4fr;
    align-items: center;
  }
}

.link-developer {
  cursor: pointer; 
  width: max-content;
}
.link-developer:hover {
  text-decoration: underline;
}

.sidebar-profile-section-setup{
  position: fixed;
  bottom: 10px;
  left: 10px;
  gap: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* .sidebar-profile-section-setup .user-image{
    display: inline-block;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    vertical-align: middle;
    overflow: hidden;
} */
 
 .user-image{
    display: inline-block;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    vertical-align: middle;
    overflow: hidden;
}
.logout-btn{
cursor: pointer;

}

.sidebar__logout__button {
  font-weight: 300;
  transition: all 0.3s;
  cursor: pointer;
}

.sidebar__logout__button:hover {
  font-weight: 600;
}

</style>
